import { Divider } from "../../../../../../components/ui/Divider/Divider";
import { MobileTableRow } from "./TableRow/MobileTableRow";

import { StackStyled } from "./IpsTableMobile.styled";

export const IpsTableMobile = function ({ ips, webRtcStatus, userIp }) {
  return (
    <StackStyled spacing={2} divider={<Divider />}>
      {webRtcStatus ? (
        ips.map(({ ip }, idx) => (
          <MobileTableRow
            ip={ip}
            provider="Public IPv4"
            status={webRtcStatus}
            key={idx}
          />
        ))
      ) : (
        <MobileTableRow
          ip={userIp}
          provider="Public IPv4"
          status={webRtcStatus}
        />
      )}
    </StackStyled>
  );
};
